import {
  LOAD_COMPANY,
  SHOW_COMPANY,
  CREATE_COMPANY,
  UPDATE_COMPANY,
  DELETE_COMPANY,
  IMPORT_COMPANY,
  EXPORT_COMPANY,
} from "./actions";

const msg = {
  success_msg: "",
  err_msg: "",
};

const initialState = {
  lists: [],
  total_rows: 0,
  loading: false,
  shouldReload: false,
        data: {
        id: "",
        code: "",
        name: "",
        tax_id: "",
        phone: "",
        email: "",
        address: "",
        logo: "",
        idcard_required: "N",
        is_franchise: "N",
        parent_company_id: "",
        province_id: "",
        section_id: "",
      },
  ...msg,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CREATE_COMPANY.REQUEST:
    case UPDATE_COMPANY.REQUEST:
    case DELETE_COMPANY.REQUEST:
    case IMPORT_COMPANY.REQUEST:
    case EXPORT_COMPANY.REQUEST:
      return {
        ...state,
        ...msg,
        loading: true,
        shouldReload: false,
      };
    case LOAD_COMPANY.REQUEST:
    case SHOW_COMPANY.REQUEST:
      return {
        ...initialState,
        ...msg,
        loading: true,
        shouldReload: false,
      };

    case LOAD_COMPANY.SUCCESS:
      return {
        ...state,
        lists: action.payload.data.data,
        total_rows: action.payload.data.total_rows,
        loading: false,
      };

    case SHOW_COMPANY.SUCCESS:
      return {
        ...state,
        data: action.payload.data.data,
        loading: false,
      };

    case CREATE_COMPANY.SUCCESS:
      return {
        ...state,
        success_msg: "save_success",
        loading: false,
      };

    case UPDATE_COMPANY.SUCCESS:
      return {
        ...state,
        success_msg: "edit_success",
        loading: false,
      };

    case DELETE_COMPANY.SUCCESS:
      return {
        ...state,
        success_msg: "delete_success",
        lists: state.lists.filter((x) => x.id !== action.payload.id),
        loading: false,
        shouldReload: true,
      };

    case IMPORT_COMPANY.SUCCESS:
      return {
        ...state,
        success_msg: "import_success",
        loading: false,
        shouldReload: true,
      };

    case EXPORT_COMPANY.SUCCESS:
      return {
        ...state,
        success_msg: "export_success",
        loading: false,
      };
    case LOAD_COMPANY.FAILURE:
    case SHOW_COMPANY.FAILURE:
    case CREATE_COMPANY.FAILURE:
    case UPDATE_COMPANY.FAILURE:
    case DELETE_COMPANY.FAILURE:
    case IMPORT_COMPANY.FAILURE:
    case EXPORT_COMPANY.FAILURE:
      return {
        ...state,
        err_msg: action.payload.err,
        loading: false,
        shouldReload: false,
      };

    default:
      return state;
  }
};
